/**
 * Supported chain constants
 */
export const CHAINS = [
  { id: 'arbitrum', name: 'Arbitrum', cost: '~$0.50', time: '~1 min' },
  { id: 'ethereum', name: 'Ethereum', cost: '~$12', time: '~5 min' },
];

export const CHAIN_IDS = CHAINS.map(c => c.id);
export const CHAIN_NAMES = CHAINS.map(c => c.name);
